var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankKbSecurities(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 23,
    viewBox: "0 0 32 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 23,
    rx: 3,
    fill: "#F8B500"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 7H7.64512V11.0285L13.1838 7H15.5149L9.66081 11.065L16 16H13.6721L7.64512 11.1775V16H6V7Z",
    fill: "#1B1B1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7999 14.9782H18.6147V11.8129H21.7151C23.4974 11.8129 24.3034 12.3853 24.3034 13.4203C24.3034 14.291 23.7785 14.9782 21.7999 14.9782ZM18.6147 8.0245H21.7151C23.5793 8.0245 24.0237 8.58358 24.0237 9.41879C24.0237 10.3789 23.1218 10.7906 21.9015 10.7906H18.6147V8.0245ZM23.5982 11.3008V11.2632C24.7346 11.0623 25.5899 10.3143 25.5899 9.22796C25.5899 7.70018 24.3504 7 21.9816 7H17V16H22.1398C24.8918 16 26 14.8369 26 13.4941C26 12.4244 25.2289 11.4731 23.5982 11.3008Z",
    fill: "#1B1B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankKbSecurities);
export default __webpack_public_path__ + "static/media/BankKBSecurities.bd6191917be8ebbf95f93b712c7f749d.svg";
export { ForwardRef as ReactComponent };